import { put, takeLatest } from "@redux-saga/core/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { call } from "redux-saga/effects";
import fetchAPI, { ApiResponse, HttpMethod } from "../../../utils/api";
import loginPageSlice from "../../login-page/store/slice";
import { showError, showSuccess } from "../../toaster/store/slice";
import { ChangePasswordFormValues } from "../ChangePasswordPage";
import changePasswordPageSlice from "./slice";

type ChangePasswordResponse = ApiResponse<{ success: boolean }>;

function* changePasswordPageSaga() {
  yield takeLatest(changePasswordPageSlice.actions.sendRequest, handleReset);
}

function* handleReset({ payload }: PayloadAction<ChangePasswordFormValues>) {
  const response: ChangePasswordResponse = yield call(
    fetchAPI,
    `/change-password`,
    {
      method: HttpMethod.POST,
      body: JSON.stringify(payload),
    }
  );

  if (response && response.success) {
    yield put(loginPageSlice.actions.logout());

    yield put(showSuccess("Password change successful. Please sign in again."));
  } else {
    yield put(
      showError("Something went wrong. Please try again or contact support.")
    );
  }

  yield put(changePasswordPageSlice.actions.setIsLoading(false));
}

export default changePasswordPageSaga;
